import { Route, Router } from "@solidjs/router";
import { lazy } from "solid-js";
import { render } from "solid-js/web";
import { AppLayout } from "@/components/AppLayout";
import { setLoginDialogOpen } from "@/state/auth";
import { openChat } from "@/state/chat";
import { setSettingsOpen } from "@/state/settings";
import { setIdentityEditorOpen } from "@/state/identity";
import "./soluid.css";
import "./styles.css";

// 起動前にテーマを当てて、初回描画のちらつきを避ける
const savedTheme = localStorage.getItem("talkers.theme");
document.documentElement.setAttribute("data-theme", savedTheme === "dark" ? "dark" : "light");

// #avatar / #login で該当のダイアログを直接開ける (案内リンク用)
if (window.location.hash === "#avatar") setIdentityEditorOpen(true);
if (window.location.hash === "#login") setLoginDialogOpen(true);
if (window.location.hash === "#chat") void openChat();
if (window.location.hash === "#settings") setSettingsOpen(true);

const Home = lazy(() => import("@/pages/Home"));
const CategoryPage = lazy(() => import("@/pages/CategoryPage"));
const ThreadPage = lazy(() => import("@/pages/ThreadPage"));
const ProfilePage = lazy(() => import("@/pages/ProfilePage"));
const DevicePage = lazy(() => import("@/pages/DevicePage"));

const root = document.getElementById("root");
if (root === null) throw new Error("#root が見つかりません");

render(
  () => (
    <Router root={AppLayout}>
      <Route path="/" component={Home} />
      <Route path="/c/:slug" component={CategoryPage} />
      <Route path="/t/:threadId" component={ThreadPage} />
      <Route path="/u/:handle" component={ProfilePage} />
      <Route path="/device" component={DevicePage} />
    </Router>
  ),
  root,
);
